import React, { useEffect, useState } from "react";
import LoaderBar from "./LoaderBar";

const AlertModel = ({
  title = "",
  text = "",
  open,
  closeModal,
  is_loading,
  children,
}) => {
  // const displayStyle = open ? "block" : "none";

  if (open) document.body.classList.add("scroll-none");
  else if (!open) document.body.classList.remove("scroll-none");

  const [displayStyle, setDisplayStyle] = useState("none");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (open) {
      setDisplayStyle("block");
      setAnimate(true);
    } else {
      setAnimate(false);
      setTimeout(() => {
        setDisplayStyle("none");
      }, 500);
    }
  }, [open]);

  return (
    <div
      className={`modal forgotModal`}
      id="alert_modal"
      tabIndex="-1"
      aria-labelledby="loginModalLabel"
      aria-hidden="true"
      style={{ display: displayStyle }}
    >
      <div
        className={`modal-dialog modal-md modal-dialog-scrollable ${
          animate
            ? "animate__animated animate__faster animate__fadeInDownBig"
            : "animate__animated animate__fadeOutUpBig"
        }`}
      >
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => closeModal()}
            >
              <img src={`/img/circle-cross.svg`} />
            </button>
            <span className="titleName"> {title} </span>
          </div>
          <div className="modal-body">{text}</div>
          <div className="modal-footer">
            <div className="invt-btns button">
              <button
                type="button"
                className="btn SaveBtn"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModel;
